/* eslint-disable id-length */
import { getSubSteps } from '#models/general/steps';

import { getStatementInformationPageFields } from './statementInformation';

export const STATEMENTS_SUBSTEP_TARGET = 'AdelphiCaskFillingModal';

export const STATEMENTS_SUBSTEPS_IDS = {
  STATEMENT_INFORMATION: 'statementInformation'
};

const STATEMENTS_NEXT_SUBSTEPS = {};

const STATEMENTS_PREVIOUS_SUBSTEPS = {};

export const STATEMENTS_SUBSTEPS = getSubSteps(
  STATEMENTS_SUBSTEP_TARGET,
  STATEMENTS_SUBSTEPS_IDS,
  STATEMENTS_NEXT_SUBSTEPS,
  STATEMENTS_PREVIOUS_SUBSTEPS
);

export const STATEMENTS_COMPLETE_FIELDS = {
  [STATEMENTS_SUBSTEPS_IDS.STATEMENT_INFORMATION]: getStatementInformationPageFields
};

export const STATEMENTS_SUBSTEPS_ADDITION_PROPS = {
  [STATEMENTS_SUBSTEPS_IDS.STATEMENT_INFORMATION]: {
    oneColumnForm: true
  }
};

export const ADELPHI_STATEMENTS_SUBSTEPS_INFO = {
  target: STATEMENTS_SUBSTEP_TARGET,
  substeps: STATEMENTS_SUBSTEPS,
  fields: STATEMENTS_COMPLETE_FIELDS,
  additionalProps: STATEMENTS_SUBSTEPS_ADDITION_PROPS
};

export const STATEMENTS_INFORMATION_FIELDS = {
  PERIOD_ID: 'periodId',
  PREVIOUS_PERIOD_ID: 'prevPeriodId',
  FEINT_PERIOD_ID: 'feintPeriodId'
};
